import ProgressBarSVG from './ProgressBarSVG';

export default ProgressBarSVG;



// WEBPACK FOOTER //
// ./src/shared/components/ProgressBarSVG/index.js